var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSettingsHd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7268_3017)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9999 4H9.00567C8.77301 4 8.66704 4 7.79676 6.37628L7.76401 6.46278L6.94489 6.80364L6.86657 6.7704C5.51572 6.18906 4.72698 5.89427 4.52137 5.89427C4.43794 5.89427 4.34059 5.93248 4.2851 5.98827L2.93255 7.33777C2.76097 7.51053 2.6898 7.58288 3.7559 9.87921L3.79508 9.96437L3.46014 10.7783L3.37818 10.8106C0.999878 11.7488 0.999878 11.8403 0.999878 12.0847V13.9935C0.999878 14.2385 0.999878 14.3403 3.3829 15.2121L3.46808 15.2428L3.80307 16.0543L3.76709 16.1372C2.75457 18.4824 2.81824 18.547 2.9905 18.7219L2.99076 18.7222L4.34001 20.0697C4.39657 20.1252 4.49446 20.1648 4.57793 20.1648C4.65348 20.1648 4.88323 20.1648 6.8803 19.2426L6.96027 19.2044L7.78421 19.5445L7.81623 19.6286C8.75534 22 8.85181 22 9.0855 22H10.9944C11.2341 22 11.3335 22 12.2045 19.6221L12.2369 19.5356L13.0573 19.197L13.1354 19.2295C14.4852 19.8125 15.2735 20.1067 15.4778 20.1067C15.5605 20.1067 15.6587 20.0697 15.7151 20.0126L17.0699 18.6602L17.0701 18.66C17.2404 18.4865 17.3109 18.4146 16.2433 16.1214L16.2036 16.0352L16.538 15.2248L16.6178 15.1929C18.9999 14.2498 18.9999 14.1579 18.9999 13.9132V12.0055C18.9998 11.8059 18.9998 11.7017 17.7101 11.2H12.5133C12.8775 11.7075 13.0922 12.3293 13.0922 13.0005C13.0922 14.7065 11.705 16.096 10.0002 16.096C8.29469 16.096 6.90724 14.7068 6.90724 13.0005C6.90724 11.2942 8.29458 9.90691 9.9999 9.90675V4Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7268_3017)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.9999,
    width: 12,
    height: 10,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "red",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1999 0C11.5371 0 10.9999 0.559644 10.9999 1.25V8.75C10.9999 9.44036 11.5371 10 12.1999 10H21.7999C22.4626 10 22.9999 9.44036 22.9999 8.75V1.25C22.9999 0.559644 22.4626 0 21.7999 0H12.1999ZM16.575 7.5V2.235H15.3439V4.2975H13.4286V2.235H12.1974V7.5H13.4286V5.3325H15.3439V7.5H16.575ZM20.7543 2.565C20.3559 2.345 19.8903 2.235 19.3575 2.235H17.4639V7.5H19.3575C19.8855 7.5 20.3487 7.39 20.7471 7.17C21.1503 6.95 21.4599 6.64 21.6759 6.24C21.8967 5.84 22.0071 5.3825 22.0071 4.8675C22.0071 4.3475 21.8967 3.89 21.6759 3.495C21.4599 3.095 21.1527 2.785 20.7543 2.565ZM20.3655 5.9925C20.1063 6.2575 19.7439 6.39 19.2783 6.39H18.6951V3.33H19.2783C19.7439 3.33 20.1063 3.465 20.3655 3.735C20.6247 4.005 20.7543 4.3825 20.7543 4.8675C20.7543 5.3525 20.6247 5.7275 20.3655 5.9925Z",
    fill: "#FF443A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7268_3017",
    x: -0.00012207,
    y: 4,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7268_3017"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7268_3017",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7268_3017"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.9999,
    width: 12,
    height: 10,
    rx: 2,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettingsHd);
export default __webpack_public_path__ + "static/media/icon-settings-hd.ea5f7b551d1cecd3e0e2be0b437a180e.svg";
export { ForwardRef as ReactComponent };